var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorClosedBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-2 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-3, .cls-4 {\n        fill: none;\n        \n      stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 13.73,
    y1: 62.32,
    x2: 61.73,
    y2: 62.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m21.48,62.32V14.94c0-1.06.86-1.92,1.92-1.92h28.67c1.06,0,1.92.86,1.92,1.92v47.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 26.57,
    cy: 35.65,
    r: 0.96
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 -6.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 0,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.2,
    y: 0
  }, "oo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 16.87,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.03,
    y: 0,
    xmlSpace: "preserve"
  }, " Closed"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorClosedBlack);
export default __webpack_public_path__ + "static/media/__Door - Closed Black.22940022568867881bf13f86dee31438.svg";
export { ForwardRef as ReactComponent };